import { render, staticRenderFns } from "./switchProfilePin.vue?vue&type=template&id=4ff9354d&scoped=true&"
import script from "./switchProfilePin.vue?vue&type=script&lang=js&"
export * from "./switchProfilePin.vue?vue&type=script&lang=js&"
import style0 from "./switchProfilePin.vue?vue&type=style&index=0&id=4ff9354d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff9354d",
  null
  
)

export default component.exports